import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      {/* back to top start */}
      <div className="back-to-top-wrapper back_to_top-2">
        <button id="back_to_top" type="button" className="back-to-top-btn">
          <svg
            width={12}
            height={7}
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 6L6 1L1 6"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
      {/* back to top end */}
      {/* header-area-start */}
      <header>
        <div
          id="header-sticky"
          className="tptransparent__header header-green header-spaces"
        >
          <div className="container">
            <div className="tp-mega-menu-wrapper">
              <div className="row align-items-center">
                <div className="col-xl-1 col-lg-6 col-sm-4 col-6">
                  <div className="tplogo__area">
                    <a href="/">
                      <img src="/images/logo.png" width={"85px"} alt="logo" />
                    </a>
                  </div>
                </div>
                <div className="col-xl-7 col-lg-5  d-none d-xl-block">
                  <div className="tpmenu__area main-mega-menu pl-100">
                    <nav className="tp-main-menu-content">
                      <ul>
                        <li className="has-mega-menu">
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <a href="/about-us">About Us</a>
                        </li>
                        <li className="has-mega-menu">
                          <a href="/services">
                            Services{" "}
                            <i
                              className="fa-solid fa-chevron-down"
                              style={{ marginLeft: "6px", fontSize: "12px" }}
                            ></i>
                          </a>
                          <div className="tp-mega-menu tp-submenu submenu">
                            <div className="row">
                              <div className="col-xl-6">
                                <div className="tp-menu-banner">
                                  <h5 className="tp-menu-banner-title">
                                    Fintech Services
                                  </h5>
                                  <ul>
                                    <li>
                                      <a href="/services">
                                        <span>
                                          <i className="fa-solid fa-fingerprint"></i>
                                        </span>
                                        AEPS
                                      </a>
                                    </li>
                                    <li>
                                      <a href="/services">
                                        <span>
                                          <i className="fa-solid fa-money-bill-transfer"></i>
                                        </span>
                                        DMT
                                      </a>
                                    </li>
                                    <li>
                                      <a href="/services">
                                        <span>
                                          <i className="fa-solid fa-building-columns"></i>
                                        </span>
                                        CMS
                                      </a>
                                    </li>
                                    <li>
                                      <a href="/services">
                                        <span>
                                          <i className="fa-solid fa-file-invoice-dollar"></i>
                                        </span>
                                        Utility Bill Payments
                                      </a>
                                    </li>
                                    <li>
                                      <a href="/services">
                                        <span>
                                          <i className="fa-solid fa-id-card"></i>
                                        </span>
                                        PAN Card
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className="col-xl-6">
                                <div className="tp-menu-banner-wrap">
                                  <div className="tp-menu-banner-content">
                                    <span>Happy Pay Fintech</span>

                                    <h5 className="tp-menu-banner-title-2">
                                      Secure Digital <br /> Financial Services{" "}
                                      <br /> for India
                                    </h5>

                                    <p
                                      style={{
                                        color: "#cfcfcf",
                                        fontSize: "14px",
                                      }}
                                    >
                                      AEPS, DMT, CMS, Utility Bill Payments &
                                      PAN Card services for retailers and
                                      customers with fast and safe transactions.
                                    </p>

                                    <div className="tp-menu-banner-btn">
                                      <a href="/services">
                                        View Services
                                        <span>
                                          <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                      </a>
                                    </div>
                                  </div>

                                  <div className="tp-menu-banner-thumb">
                                    <i
                                      className="fa-solid fa-coins"
                                      style={{
                                        fontSize: "80px",
                                        color: "#22c55e",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li className="">
                          <a href="blog.html">
                            Pages{" "}
                            <i
                              className="fa-solid fa-chevron-down"
                              style={{ marginLeft: "6px", fontSize: "12px" }}
                            ></i>
                          </a>
                          <ul className="tp-submenu submenu">
                            <li>
                              <a href="/terms-and-conditions">
                                Terms & Conditions
                              </a>
                            </li>
                            <li>
                              <a href="/privacy-policy">Privacy Policy</a>
                            </li>
                            <li>
                              <a href="/refund-policy">Refund Policy</a>
                            </li>
                            <li>
                              <a href="/grievance-policy">Grievance Policy</a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="/contact-us">Contact Us</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-sm-8 col-6">
                  <div className="tpheader__right d-flex align-items-center justify-content-end">
                    <div className="d-none d-md-block"></div>
                    <div className="tpheader-btn-two ml-25 d-none d-md-block">
                      <a href="https://app.happypayfintech.com/login">Login</a>
                    </div>
                    <div className="offcanvas-btn d-xl-none ml-20">
                      <button className="offcanvas-open-btn">
                        <i className="fa-solid fa-bars" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* header-area-end */}
    </>
  );
};

export default Header;
